import type { FacebookCampaign } from '@feathr/blackbox';

export function validateStepGeneral(campaign: FacebookCampaign): string[] {
  return campaign.validate(['name', 'objective_type'], false).errors;
}
